
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/voice",
      function () {
        return require("private-next-pages/voice/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/voice"])
      });
    }
  